import { apiSlice } from "../";
import { getToken } from "shared/utils/getToken";

export interface Etapa {
  idEtapa: number;
  nome: string;
}

const etapaSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEtapas: builder.query<Etapa[], boolean | void>({
      query: (ativo) => ({
        url: "etapa",
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: {
          ativo: ativo,
        },
      }),
      providesTags: ["Etapas"],
    }),
    getEtapaAtual: builder.query<Etapa, number | void>({
      query: (idEdicao) => ({
        url: `etapa/atual/${idEdicao}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
      providesTags: ["Etapas"],
    }),
    deleteEtapa: builder.mutation<void, number>({
      query: (id) => ({
        url: `etapa/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
      invalidatesTags: ["Etapas", "EtapasPadrao"],
    }),
    reativarEtapa: builder.mutation<void, number>({
      query: (id) => ({
        url: `etapa/${id}/reativar`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
      invalidatesTags: ["Etapas"],
    }),
    updateEtapa: builder.mutation<void, { idEtapa: number; nome: string }>({
      query: (data) => ({
        url: `etapa/${data.idEtapa}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: {
          nome: data.nome,
        },
      }),
      invalidatesTags: ["Etapas", "EtapasPadrao"],
    }),
    postEtapa: builder.mutation<void, { nome: string }>({
      query: (data) => ({
        url: `etapa`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: {
          nome: data.nome,
        },
      }),
      invalidatesTags: ["Etapas"],
    }),
  }),
});

export const {
  useGetEtapasQuery,
  useDeleteEtapaMutation,
  useReativarEtapaMutation,
  useUpdateEtapaMutation,
  usePostEtapaMutation,
  useGetEtapaAtualQuery,
} = etapaSlice;
